var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAffordability(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "marker (2) 1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 13.7634,
    fill: "#212121",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M57.6287 38.8414C57.0708 37.4424 56.2688 36.136 55.2654 34.9933V28.8498C55.2654 27.8279 54.8066 26.8786 54.0045 26.2436C53.2157 25.6202 52.2073 25.3953 51.2303 25.6251C48.2185 26.3445 45.9592 28.0544 44.7495 30.4969H35.8988C31.6393 30.4969 27.8155 32.4119 25.3053 35.4067C23.3249 35.1173 23.5642 32.1473 25.5578 32.1506C27.7148 32.1423 27.7164 28.8515 25.5578 28.8432C20.3015 28.8267 18.7436 36.1294 23.4652 38.2841C20.5623 44.2705 23.0873 51.9799 28.8585 55.1716V55.3022C28.8618 60.8437 36.681 62.1121 38.4782 56.9559H42.345C44.1422 62.1154 51.9614 60.8404 51.9647 55.3022V55.1501C54.5392 53.6568 56.5378 51.3466 57.6287 48.6114C58.9836 48.322 60.2164 47.2091 60.2164 45.3801V42.0727C60.2164 40.2437 58.9819 39.1308 57.6287 38.8414ZM50.3144 42.0727C48.1558 42.0628 48.1558 38.7753 50.3144 38.7653C52.473 38.7753 52.473 42.0628 50.3144 42.0727ZM30.5963 28.0362C29.6688 18.7905 43.3698 17.8958 43.7131 27.1895H35.9004C34.0504 27.1895 32.2697 27.4955 30.5963 28.0362Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAffordability);
export default __webpack_public_path__ + "static/media/affordability.c46ebba6c9779fb2421044bc6dfc5d7d.svg";
export { ForwardRef as ReactComponent };